/**
 *  获取多语言
 */
import Vue from 'vue'
import VueI18n from "vue-i18n"
import Cookies from 'js-cookie';
import storeLocal from 'store';
import xmail from "@/api/api";
Vue.use(VueI18n);

let user_language = {
  UNKNOWN: 0,         //UNKNOWN
  CN: 1,         //中文简体
  HK: 2,         //中文繁体
  EN: 3,         //英文
  JP: 4,         //日语
  KR: 5,         //韩语
};
const getI18n = (function () {
    let configSetting = storeLocal.get('Pwm-configSetting');
    let configLanguage = '';
    if (configSetting) {
        switch (configSetting.displaySetting.language) {
          case user_language.CN:
            configLanguage = 'cn';
            break;
          case user_language.EN:
            configLanguage = 'en';
            break;
          case user_language.HK:
            configLanguage = 'hk';
            break;
          default:
            configLanguage = '';
        }
    }
    const i18n = new VueI18n({
        locale: configLanguage || 'cn',
        messages: {
          cn: require("@/vueI18n/cn"),
          en: require("@/vueI18n/en"),
          hk: require("@/vueI18n/hk"),
        },
    });

    return i18n

})();

export default getI18n;



// WEBPACK FOOTER //
// ./src/vueI18n/getI18n.js